import {NgModule} from "@angular/core";
import {SharedModule} from "../../shared.module";
import {PackComponent} from "./pack.component";
import {ProductBuyBoxModule} from "../product/buy-box/product-buy-box.module";
import {ProductThumbCarouselModule} from "../product/product-thumb-carousel/product-thumb-carousel.module";
import {ProductSafePipe} from "../product/safe/product-safe.pipe";
import {PdpTemplateComponent} from '@usana/ux/cms';

@NgModule({
    imports: [
        SharedModule,
        ProductBuyBoxModule,
        ProductThumbCarouselModule,
        ProductSafePipe,
        PdpTemplateComponent
    ],
    declarations: [
        PackComponent
    ],
    exports: [
        PackComponent
    ]
})
export class PackModule { }
